import React, { useContext, useMemo } from 'react'

import { connect } from 'react-redux'
import InternshipsTableHead from './InternshipsTableHead'
import { InternshipsDataContext } from '../../../Context/InternshipsManager/InternshipsDataProvider'
import { getTranslate } from 'react-localize-redux'
import InternshipsTableBody from './InternshipsTableBody'
import { InternshipsManagerContext } from '../../../Context/InternshipsManager/InternshipsManagerProvider'
import Cookies from 'js-cookie'
import { getUser } from '../../../reducers/UserReducer'
import { INSTITUTION_CONTEXT } from '../../../utils/constants'

const mapStateToProps = state => ({ t: getTranslate(state.locale), user: getUser(state.getUser) })

const InternshipsTable = ({ loading, user }) => {
  const { dataProvider, internshipProvider } = useContext(InternshipsManagerContext)
  const { getDataReady, onTableLeave } = useContext(InternshipsDataContext)

  const height = useMemo(() => {
    if (user.context === INSTITUTION_CONTEXT) {
      return `calc(100vh - ${Cookies.get('switch_user_id') ? '242px' : '201px'})`
    } else {
      return `calc(100vh - ${Cookies.get('switch_user_id') ? '177px' : '136px'})`
    }
  }, [Cookies.get('switch_user_id'), user.context])

  return (
    <div className='internship-manager-table' style={{ height }}>
      {dataProvider.context && internshipProvider.context && (
        <table className='internships-manager' onMouseLeave={onTableLeave}>
          <InternshipsTableHead />
          <InternshipsTableBody loading={loading || !getDataReady.schools || !getDataReady.institutions || !getDataReady.students} />
        </table>
      )}
    </div>
  )
}

export default connect(mapStateToProps)(InternshipsTable)
